import { render, staticRenderFns } from "./CategoriesWidget.vue?vue&type=template&id=a497f378"
import script from "./CategoriesWidget.vue?vue&type=script&setup=true&lang=js"
export * from "./CategoriesWidget.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports